import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { push } from 'connected-react-router';

import LoadingWrapper from 'components/Common/LoadingWrapper';

import { closeLinkedAccountsModal } from 'actions';

import ModalWrapper from '../ModalWrapper';
import LinkedAccountRow from './LinkedAccountRow';

const LinkedAccountsModal = () => {
  const dispatch = useDispatch();
  const { linkedAccountsModalShown, isGettingLinkedAccounts, linkedAccounts, error } = useSelector(state => state.whsManagement);

  const closeModal = () => {
    dispatch(closeLinkedAccountsModal());
  };

  const navigateToImyStructure = (accountId) => {
    dispatch(push(`/w8imystructure/${ accountId }`));
  };

  const navigateToWithholdingStatement = (accountId) => {
    dispatch(push(`/whd-statement/${ accountId }`));
  };

  return (
    <ModalWrapper
      isOpen={ linkedAccountsModalShown }
      title="Linked Accounts"
      btnCancelTitle="Close"
      onCancel={ e => closeModal() }
      showFooter={ false }
      modalSize="modal-lg whd-rates-modal"
    >
      { isGettingLinkedAccounts && <LoadingWrapper loaded={ !isGettingLinkedAccounts } message="Fetching Linked Accounts" /> }
      { !isGettingLinkedAccounts && linkedAccounts && <div>
        <label className="form-label">Origin Account</label>
        <table className="table table-striped table-hover table-bordered">
          <thead>
            <tr>
              <th style={ { textAlign: 'center' } }>Account Number</th>
              <th style={ { textAlign: 'center' } }>Account Name</th>
              <th style={ { textAlign: 'center' } }>Shareholder Id</th>
              <th style={ { textAlign: 'center' } }>Shareholde Name</th>
              <th style={ { textAlign: 'center' } }>View</th>
            </tr>
          </thead>
          <tbody>
            { linkedAccounts.length > 0 && <LinkedAccountRow
              data={ {
                accountId: linkedAccounts[0].originAccountId,
                accountNumber: linkedAccounts[0].originAccountNumber,
                accountName: linkedAccounts[0].originAccountName,
                customerId: linkedAccounts[0].originCustomerId,
                customerIdentifier: linkedAccounts[0].originCustomerIdentifier,
                customerName: linkedAccounts[0].originCustomerName,
              } }
              showActions
              onTreeviewClick={ accountId => navigateToImyStructure(accountId) }
              onWhsClick={ accountId => navigateToWithholdingStatement(accountId) }
            /> }
            { linkedAccounts.length <= 0 && <tr><td colSpan="5" style={ { textAlign: 'center' } }><p><b>No Data to Show</b></p></td></tr> }
          </tbody>
        </table>
        <label className="form-label">Linked Accounts</label>
        <table className="table table-striped table-hover table-bordered">
          <thead>
            <tr>
              <th style={ { textAlign: 'center' } }>Account Number</th>
              <th style={ { textAlign: 'center' } }>Account Name</th>
              <th style={ { textAlign: 'center' } }>Shareholder Id</th>
              <th style={ { textAlign: 'center' } }>Shareholder Name</th>
            </tr>
          </thead>
          <tbody>
            { linkedAccounts.length > 0 && linkedAccounts.map(a => <LinkedAccountRow data={ a } />) }
            { linkedAccounts.length <= 0 && <tr><td colSpan="5" style={ { textAlign: 'center' } }><p><b>No Data to Show</b></p></td></tr> }
          </tbody>
        </table>
      </div> }
      { error && <div>{ error }</div>}
    </ModalWrapper>
  );
};

export default LinkedAccountsModal;
